import Slider from '../app/slider.js';

export default {
    init() {
        // JavaScript to be fired on the home page
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
        new Slider('section.banner', {
            nav: true,
            navText: ['<i class="icon icon-chevron-left"></i>', '<i class="icon icon-chevron-right"></i>'],
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/Home.js